import React, { useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { Nav, Navbar, Row, Col } from "react-bootstrap";
import { navbarBreakPoint } from "config";
import Flex from "components/common/Flex";
import Logo from "components/common/Logo";
import NavbarVerticalMenu from "components/navbar/vertical/NavbarVerticalMenu";
import ToggleButton from "components/navbar/vertical/ToggleButton";
import OsirisRoutes from "routes/osirisSiteMaps";
import { capitalize } from "helpers/utils";
import GiveFeedbackCard from "components/navbar/vertical/GiveFeedbackCard";
import { useAppContext } from "providers/AppProvider";

const NavbarVerticalOsiris = () => {
  const {
    config: { isNavbarVerticalCollapsed, showBurgerMenu },
  } = useAppContext();

  const HTMLClassList = document.getElementsByTagName("html")[0].classList;

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add("navbar-vertical-collapsed");
    } else {
      HTMLClassList.remove("navbar-vertical-collapsed");
    }
    return () => {
      HTMLClassList.remove("navbar-vertical-collapsed-hover");
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add("navbar-vertical-collapsed-hover");
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    clearTimeout(time);
    HTMLClassList.remove("navbar-vertical-collapsed-hover");
  };

  const NavbarLabel = ({ label }) => (
    <Nav.Item as="li">
      <Row className="mt-3 mb-2 navbar-vertical-label-wrapper">
        <Col xs="auto" className="navbar-vertical-label navbar-vertical-label">
          {label}
        </Col>
        <Col className="ps-0">
          <hr className="mb-0 navbar-vertical-divider"></hr>
        </Col>
      </Row>
    </Nav.Item>
  );

  return (
    <Navbar
      expand={navbarBreakPoint}
      className="navbar-vertical navbar-transparent"
      variant="light"
    >
      <Flex alignItems="center">
        <ToggleButton />
        <Logo
          at="navbar-vertical"
          textClass="text-primary"
          width={39}
          name="Osiris"
        />
      </Flex>

      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="navbar-vertical-content scrollbar">
          <Nav className="flex-column" as="ul">
            {OsirisRoutes.map((route) => (
              <Fragment key={route.label}>
                {!route.labelDisable && (
                  <NavbarLabel label={capitalize(route.label)} />
                )}
                <NavbarVerticalMenu routes={route.children} />
              </Fragment>
            ))}
          </Nav>

          <div className="navbar-vertical-divider">
            <hr className="navbar-vertical-hr my-2" />
          </div>
          {/* TODO: Remove this once we have it ready */}
          {import.meta.env.VITE_REACT_APP_ENVIRONMENT !== "Production" && (
            <GiveFeedbackCard />
          )}
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

NavbarVerticalOsiris.propTypes = {
  label: PropTypes.string,
};

export default NavbarVerticalOsiris;
